import React, { useState, useEffect } from 'react'
import { Modal, message } from 'antd'
import request from '../../utils/request'
import dyTrackUtil from '../../utils/dyTrack'
import { renderCompat } from '../../utils/renderCompat'
import Verb from './verb'
import './index.less'

const baseItemUrl = 'https://item.taobao.com/item.htm?id='

const GOODS_TYPE = {
  douyin: 100,
  taobao: 101
}

const COLLECT_TYPE = {
  host: 'host',
  item: 'item',
  shop: 'shop'
}

const displayInfo = {
  [COLLECT_TYPE.shop]: {
    title: '该店铺暂未收录',
    subTitle: '我们将在店铺收录后为您呈现店铺的数据'
  },
  [COLLECT_TYPE.item]: {
    title: '该商品暂未收录',
    subTitle: '我们将在商品收录后为您呈现商品的数据'
  },
  [COLLECT_TYPE.host]: {
    title: '该达人暂未激活',
    subTitle: '我们将在监控达人后的48时内为您呈现该达人的数据'
  },
}

let div = null

export default function CollectModal({ baseInfo = {}, type, id }) {
  const [visible, setVisible] = useState(true)
  const [showVerb, setShowVerb] = useState(false)
  const [collectFlag, setCollectFlag] = useState(false)
  const { coverUrl, shopName, title, userName, monitorFlag, onChange, goodsType } = baseInfo

  useEffect(() => {
    setCollectFlag(monitorFlag)
  }, [baseInfo.monitorFlag])

  function closeModal() {
    setVisible(false)
    if (div) {
      document.body.removeChild(div)
    }
  }

  async function collect() {
    if (type === COLLECT_TYPE.shop) {
      setShowVerb(true)
      return
    }
    const url = 'item/unknown-item-url-add'
    try {
      const res = await request.get(url, { params: { itemUrl: baseItemUrl + id } })
      if (res) {
        message.success('商品收录成功')
        setCollectFlag(true)
      }
    } catch (e) {
      console.error(e)
      message.error(e.errorDesc || '网络链接失败，请稍后再试')
    }
  }

  async function monitor() {
    const url = collectFlag ? '/live-bus/streamer/cancel' : '/live-bus/streamer/follow'
    try {
      const res = await request.post(url, { streamerId: id })
      if (!monitorFlag) {
        dyTrackUtil.track('DY_monitorDyHost', {
          ...dyTrackUtil.getDyTrackModule(),
          hostId: id,
          hostName: userName
        })
      }
      if (res) {
        const { shopId, _shopName } = res || {}
        if (collectFlag) {
          message.success('你已取消监控该达人')
        } else if (shopId && _shopName) {
          message.success(<>监控成功，前往监控此达人的抖音小店 <a href={`/douyin/shopDetail/?shopId=${shopId}`} target="_blank" rel="noreferrer">{_shopName}</a></>)
        } else {
          message.success(`达人 ${userName} 监控成功`)
        }
        setCollectFlag(!collectFlag)
        onChange?.()
      }
    } catch (e) {
      console.error(e)
      message.error(e.errorDesc || '网络链接失败，请稍后再试')
    }
  }

  function renderInfo() {
    if (type === COLLECT_TYPE.shop) {
      return <div className="base-info-box">
        <div className="no-shop-logo">{ shopName?.slice(0, 1) }</div>
        <div>
          <div className="title-text">{shopName}</div>

        </div>
      </div>
    }
    if (type === COLLECT_TYPE.host) {
      return <div className="base-info-box">
        <img className="cover" src={coverUrl} />
        <div>
          <div className="title-text">{userName}</div>
        </div>
      </div>
    }
    if (type === COLLECT_TYPE.item) {
      return <div className="base-info-box">
        <img className="cover" src={coverUrl} />
        <div>
          <div className="title-text">{title}</div>
          <div className="info-text">{shopName}</div>
        </div>
      </div>
    }
  }

  function renderButton() {
    if (type === COLLECT_TYPE.item && goodsType === GOODS_TYPE.douyin) {
      return null
    }
    if (type !== COLLECT_TYPE.host) {
      return (
        collectFlag
          ? <div className="collect-modal-btn collected">已收录</div>
          : <div onClick={() => collect()} className="collect-modal-btn">申请收录</div>
      )
    }
    if (type === COLLECT_TYPE.host) {
      return (
        collectFlag
          ? <div onClick={() => monitor()} className="collect-modal-btn collected">取消监控</div>
          : <div onClick={() => monitor()} className="collect-modal-btn">监控达人</div>
      )
    }
  }

  return <div>
    <Modal
      visible={visible}
      footer={null}
      width={678}
      maskClosable={false}
      onCancel={() => closeModal()}
    >
      <div>
        <div className="collect-header">
          <div className="collect-title">{displayInfo[type].title}</div>
          <div className="collect-tip">{displayInfo[type].subTitle}</div>
        </div>

        <div className="collect-item-wrapper">
          { renderInfo() }

          { renderButton() }
        </div>
      </div>
    </Modal>

    <Verb
      visible={showVerb}
      title="店铺"
      close={() => setShowVerb(false)}
      onGetInfo={() => { setShowVerb(false); setCollectFlag(true) }}
    />
  </div>
}

CollectModal.TYPE = COLLECT_TYPE

CollectModal.show = (props) => {
  return new Promise(() => {
    div = document.createElement('div')
    document.body.appendChild(div)
    renderCompat(<CollectModal {...props} />, div)
  })
}
